module.exports = __webpack_public_path__ + "static/img/1v1.f569567.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/1v1.png
// module id = ub/K
// module chunks = 28